// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Item_attributes_SalvarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/item_attributes/salvar
 *
 * Creates or updates an item attribute.
 * - Create: requires name and type only (id is null)
 * - Update: requires id, name, and type
 */
import { registerContract } from './validate'

export interface Item_attributes_SalvarInput {
so_item_attribute_name: string
so_item_attribute_type: string
so_item_attribute_id?: number
}

registerContract('Item_attributes_SalvarInput', {
  so_item_attribute_name: { type: 'string',  required: true },
  so_item_attribute_type: { type: 'string',  required: true },
  so_item_attribute_id:   { type: 'number',  required: false },
})
